import { organiceResponse } from '../charts/capital-gain/CapitalGain'
import { calculateCapitalGain } from '../charts/utils'

export const useGetTimeSeries = (capitalGain: any) => {
  if (capitalGain && capitalGain.capGainTimeSeries) {
    const { timeSeries, seriesCount } = organiceResponse({
      data: { capitalGain: { timeSeries: capitalGain?.capGainTimeSeries } }
    })
    const capitalGainValue = calculateCapitalGain({ timeSeries })
    return {
      timeSeries,
      seriesCount,
      capitalGainValue: capitalGainValue
        ? Number(Number(capitalGainValue).toFixed(2))
        : undefined
    }
  }
  return {}
}
